import React, { createContext, useContext } from "react";

import { usePolygonDraw } from "./usePolygonDraw";

const PolygonDrawContext = createContext(null);

export function PolygonDrawProvider({ children }) {
  const value = usePolygonDraw();
  return (
    <PolygonDrawContext.Provider value={value}>
      {children}
    </PolygonDrawContext.Provider>
  );
}

export function usePolygonDrawContext() {
  const context = useContext(PolygonDrawContext);
  if (!context) {
    throw new Error(
      "usePolygonDrawContext must be used within a PolygonDrawProvider",
    );
  }
  return context;
}
